import { takeLatest, put, call, SagaReturnType } from 'redux-saga/effects';
import { departmentDashboard } from '../../actions/constant';
import departmentDashboardService from '../../../services/departmentDashboard/getDepartmentDashboardCount';

const {
  GET_PENDING_SIGNATURE_PHYSICIANS_REQUEST,
  GET_PENDING_SIGNATURE_PHYSICIANS_SUCCESS,
  GET_PENDING_SIGNATURE_PHYSICIANS_FAILURE,
  GET_PENDING_SIGNATURE_PHYSICIANS_LOADING,
} = departmentDashboard;

function* getPendingSignaturePhysicians(): SagaReturnType<any> {
  try {
    yield put({ type: GET_PENDING_SIGNATURE_PHYSICIANS_LOADING });
    const response = yield call(departmentDashboardService.getPendingSignaturePhysicians);
    if (response?.status === 200) {
      yield put({ type: GET_PENDING_SIGNATURE_PHYSICIANS_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_PENDING_SIGNATURE_PHYSICIANS_FAILURE, payload: error });
  }
}

function* getPendingSignaturePhysiciansSaga() {
  yield takeLatest(GET_PENDING_SIGNATURE_PHYSICIANS_REQUEST, getPendingSignaturePhysicians);
}

export default getPendingSignaturePhysiciansSaga;
